// "Every cross-page jump must be able to go back the way it came" (Gary, 2026-09-29): the page we
// jump FROM puts its own return path (incl. row/scroll anchor) into ?back=...&label=..., and the
// target renders a "← Back to <label>" link from it. Plain URL params rather than router state so
// it survives a refresh and can be opened in a new tab.
export interface BackTarget { path: string; label: string }

export function withBack(url: string, back: BackTarget): string {
  return `${url}${url.includes('?') ? '&' : '?'}back=${encodeURIComponent(back.path)}&label=${encodeURIComponent(back.label)}`
}

// Only same-app absolute paths are honoured -- never an external/protocol-relative URL
// (open-redirect guard), since this value comes straight from the address bar.
export function readBack(params: URLSearchParams): BackTarget | null {
  const path = params.get('back')
  if (!path || !path.startsWith('/') || path.startsWith('//')) return null
  return { path, label: params.get('label') || 'previous page' }
}
